import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import UserRelationButton from './UserRelationButton';

loadDOMComponent({
	selector: 'react-user-relation-button',
	callback: ({ container }) => {
		const workplaceId = container.getAttribute('workplaceId');
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<AppContextProvider>
				<UserRelationButton workplaceId={workplaceId} userId={userId} />
			</AppContextProvider>,
			container,
		);
	},
});
